<template>
  <div>
    <header-page
      :namePage="$t('mc.pageTitles.accountingTable')"
      :links="links"
    />
    <div class="content">
      <modal
        :largeModal="!mimkInfoOnModal"
        v-show="isVisibleModalStatistic" @close="closeModals">
        <template #body>
          <span class="modal__title ">{{$t('mc.statistic.modalTitleInformation')}}</span>
          <perfect-scrollbar v-if="modalTableData.data">
            <base-table
              :blackTitle="true"
              :itemsCenter="true"
              :head="modalTableData.head"
              :columnTemplates="modalTableData.sizeColumn">
              <base-table-row
                v-for="(el, i) of modalTableData.data"
                :key="i"
                :columnTemplates="modalTableData.sizeColumn">
                <base-table-column
                  class="table-column_elipsis"
                  v-for="(item, i) of el"
                  :key="i"
                  :cellFullWidth="true">
                  <div
                    class="table-incide-cell"
                    v-if="typeof item === 'string' || typeof item === 'number' || i === 'status'">
                    <template v-if="i === 'id' || i === 'status'">
                      <template v-if="i === 'id'">
                        <router-link :to="`/master-classes/detail/${el.id}`" v-tooltip="'Переход к МК'" >
                          {{el.id}}
                        </router-link>
                      </template>
                      <div class="cell-content__status" v-if="i === 'status'">
                        <inline-svg
                          :src="require(`@/assets/svg/${el.status.svg}.svg`)"
                          class="cell-content__status-icon"
                        />
                        {{el.status.name}}
                      </div>
                    </template>
                    <template v-else>
                      {{item}}
                    </template>
                  </div>
                  <template v-else>
                    <div v-for="(objectItem, i) of item" :key="i">
                      {{objectItem}}
                    </div>
                  </template>
                </base-table-column>
              </base-table-row>
            </base-table>
          </perfect-scrollbar>
          <span v-else class="modal__title ">Информации о данном мастер классе нет</span>
          <loader v-if="loader"/>
        </template>
      </modal>
    <div class="statisti-current flex">
      <div class="flex-column mr-8">
        <span class="statistic-current__day">{{$t('mc.calendar.today')}}, {{today}}</span>
        <datepicker
            calendar-class="my-datepicker_calendar"
            class="datepicker_mimk"
            v-model="searchDate"
            @change="changeDate"
            value-type="format"
            format="DD.MM.YYYY"
            :lang="globalSettingCalendar">
          <i slot="icon-calendar">
            <inline-svg :src="require(`@/assets/svg/picker-calendar.svg`)"/>
          </i>
        </datepicker>
      </div>
      <div class="flex-column">
        <span class="statistic-current__day">{{ $t('mc.tags.tags') }}</span>
        <v-select
          v-model="filterTags"
          :options="allTags.filter(tag => !filterTags.map(tag => tag.tag_id).includes(tag.tag_id))"
          :clearable="true"
          @input="filterByTags()"
          :get-option-label="(option) => option.name"
          multiple
          class="statistic__multiselect"
          :placeholder="$t('mc.tags.tags')"
        />
      </div>
    </div>
    <loader v-if="loader" />
    <base-table
      v-else
      :itemsCenter="true"
      :titleCenter="true"
      :head="tableData.head"
      :columnTemplates="tableData.sizeColumn"
      :headHeight="'90px'"
      :sticky="true">
      <base-table-row
        v-for="(el, i) of tableData.statistic"
        :key="i"
        :columnTemplates="tableData.sizeColumn"
        :itemsCenter="true">
        <base-table-column
          :backgroundColor="item.colorCell"
          :cellFullWidth="true"
          v-for="(item, i) of el" :key="i">
          <div class="table-incide-cell" @click="callModal(i, el[0].info, item.cell)">
            <template v-if="typeof item.cell === 'string' || typeof item.cell === 'number'">
              {{item.cell}}
            </template>
            <template v-if="Array.isArray(item.cell)">
              {{item.cell.length}}
            </template>
          </div>
        </base-table-column>
      </base-table-row>
      <base-table-row
        :columnTemplates="tableData.sizeColumn"
        :itemsCenter="true">
        <base-table-column class="column__total" v-for="(el, i) of totalStatistic" :key="i">
          {{el}}
        </base-table-column>
      </base-table-row>
    </base-table>
    </div>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import militaryAndLanguage from "@/helpers/militaryAndLanguage"
import config from "@/config"
import apiTimeslots from '@/api/master-classes/timeslots'
import globalSettingCalendar from '@/helpers/globalSettingCalendar'
import tagsApi from "@/api/tags";
export default {
  data() {
    return {
      allTags: [],
      filterTags: [],
      globalSettingCalendar,
      militaryAndLanguage,
      config,
      loader: true,
      isVisibleModalStatistic: false,
      totalStatistic: {
        nameOfRow: 'Total:'
      },
      searchDate: '',
      mimkInfoOnModal: false,
      rowCurrentIndex: null,
      rowData: [],
      tableCasess: {
        McCase: {
          titles: [
            this.$t('mc.tables.statistic.bookingID'),
            this.$t('mc.tables.statistic.linkAmo'),
            this.$t('mc.tables.statistic.mimk'),
            this.$t('mc.tables.statistic.status'),
            this.$t('mc.tables.statistic.parent'),
            this.$t('mc.tables.statistic.kid'),
            this.$t('mc.tables.statistic.comment')],
          sizeOfColumn: '2.5fr 1fr 1.5fr 1.5fr 2fr 1.5fr 3fr'
        },
        mimkCase:{
          titles: [
            this.$t('mc.tables.statistic.idMimk'),
            this.$t('mc.tables.statistic.nameMimk'),
            this.$t('mc.tables.statistic.ratingMimk'),
            this.$t('mc.tables.statistic.class'),
            this.$t('mc.tables.statistic.status')],
          sizeOfColumn: 'repeat(5, 1fr)'
        }
      },
      tableData: {
        head: [
          this.$t('mc.tables.statistic.time'),
          this.$t('mc.tables.statistic.countMimks'),
          this.$t('mc.tables.statistic.overbooking'),
          this.$t('mc.tables.statistic.lidsRegistration'),
          this.$t('mc.tables.statistic.lidsRegistrationOverbooking'),
          this.$t('mc.tables.statistic.mkBeforeHour'),
          this.$t('mc.tables.statistic.mkCanceledM1'),
          this.$t('mc.tables.statistic.mkCanceledMimk'),
          this.$t('mc.tables.statistic.mkSuccess')],
        sizeColumn: '100px repeat(8, 1fr)',
        statistic: [],
      },
      modalTableData: {
        head: [],
        sizeColumn: '',
        data: [],
      },
      links: [],
    }
  },
  async created() {
    const role = cookie.get('role')
    const segment = this.$store.state.user.segment
    const m1Distribution = this.$store.state.user.segmentM1Distribution
    // Статистика у нас доступна ролям менеджера и супервизора, здесь определяем какого вида ссылки в хедере нам показывать
    if (this.$route.params.fromPath === '/' && role === 'manager' && !m1Distribution ) this.links = this.$store.state.headerLinks.managerMcLinks
    else if (this.$route.params.fromPath === '/' && role === 'manager' && m1Distribution ) this.links = this.$store.state.headerLinks.managerMcLinksWithTimetable
    else if (this.$route.params.fromPath === '/' && role === 'supervisor') this.links = this.$store.state.headerLinks.supervisorMcLinks
    else this.$route.params.fromPath.includes("supervisor") ? this.links = this.$store.state.headerLinks.supervisorMcLinks : m1Distribution ? this.links = this.$store.state.headerLinks.managerMcLinksWithTimetable : this.links = this.$store.state.headerLinks.managerMcLinks
    //Поулчаем статистику за сегодня
    this.searchDate = this.$dayjs(segment.segment_local_time, 'YYYY-MM-DD HH:mm').format('DD.MM.YYYY')
    this.statistic = await apiTimeslots.getTimeslotsStatistic(this.$dayjs(this.searchDate, 'DD.MM.YYYY').format('YYYY-MM-DD'))
    this.getStatistic()
    this.fetchTags()
    this.loader = false
  },
  methods: {
    async fetchTags() {
      this.allTags = await tagsApi.getSegmentTags(this.$store.state.user.segment.id)
    },
    async filterByTags() {
      this.loader = true
      const formatDate = this.$dayjs(this.searchDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
      this.statistic = await apiTimeslots.getTimeslotsStatistic(formatDate, this.filterTags)
      this.getStatistic()
      this.loader = false
    },
    callModal(idx, data, cellData) {
      //Если пользователь нажал на 2 или 3 колонку , то показываем данные по мимкам на слот, если на все остальные, то показываем данные по мк
      if (idx === 1 || idx === 2) {
        if (data.working_mimks.length) {
          this.isVisibleModalStatistic = true
          this.mimkInfoOnModal = true
          //Формируем данные для модалки
          this.getMimkData(data)
        }else this.$toasted.global.all_ok(this.$t('mc.toasts.noMimks'))
        //Если пользователь нажал любые из колонок кроме 2 и 3
      } else {
          if (data.bookings.length) {
            let detailBooking = data.bookings
            //Если приходит массив,значит мы его создавали сравнивая по условию(статусу) и тогда мы получаим отфильтрованные МК
            if (Array.isArray(cellData)) detailBooking = cellData
            this.getMcData(detailBooking)
            this.isVisibleModalStatistic = true
          }else this.$toasted.global.all_ok(this.$t('mc.toasts.noMc'))
        }
    },
    //Формируем Модалку для отображения МК в слоте
    getMcData(mcData) {
      //dash отображаем, если нет мимка на МК
      const dash = '__'
      //Формируем таблицу
      const tableData = mcData.map(el => {
        let svgName = 'status-wait'
        if (el.status === 'Отменен') svgName = 'status-cancel'
        if (el.status === 'Завершен') svgName = 'status-complete'
        return {
          id: el.id,
          amoLink: el.amocrm_id,
          mimkName: el.mimk_name || dash.toUpperCase(),
          status: {
            name: el.status_translated,
            svg: svgName
          },
          parentInfo: {
            parent: el.parent_name,
            parentNumber: el.parent_email,
            parentMail: el.parent_whatsapp,
          },
          studentInfo: {
            student: el.kid_name ,
            age: el.kid_age
          },
          additionalInfo: el.additional_info
        }
      })
      //Формируем тайтлы и размеры колонок для модалки с инфой о МК
      this.modalTableData.data = tableData
      this.modalTableData.sizeColumn = this.tableCasess.McCase.sizeOfColumn
      this.modalTableData.head = this.tableCasess.McCase.titles
    },
    //Формируем Модалку для отображения МИМК в слоте
    getMimkData(mimkData) {
      const dash = '__'
      const tableData = mimkData.working_mimks.map(el => {
      let tableArray = [el.mimk_id, el.full_name, el.rating, dash.toUpperCase(), dash.toUpperCase()]
        mimkData.bookings.forEach(element => {
          //Сравниваем совпадает ли айди МИМКа с айди присвоенным МК, если совпадает и у мимка есть МК, то добавляем элементы с амоайди МК и статусом в массив мимка
          if (element.mimk === tableArray[0]) {
            tableArray.splice(3, 1, element.amocrm_id)
            tableArray.splice(4, 1, element.status_translated)
          }
        });
        return tableArray
      })
      //Формируем тайтлы и размеры колонок для модалки с инфой о МИМК
      this.modalTableData.data = tableData
      this.modalTableData.sizeColumn = this.tableCasess.mimkCase.sizeOfColumn
      this.modalTableData.head = this.tableCasess.mimkCase.titles
    },
    getStatistic() {
      const isMilitaryTime = this.militaryAndLanguage()
      this.totalStatistic = Object.assign(this.totalStatistic, this.statistic.total);
      const newArrayStatistic = this.statistic.bookings.map(el => {
        //В этом объекте будут содердаться элементы ,число которых не приходят с бэка и требуют подсчета
        let filteredObject = {
          dealStatistic: [],
          hoursBeforeConfirmed: [],
          cancelM1: [],
          cancelMimk: [],
          sucssesMC: []
        }
        //Далее по определенным параметрам отправляем элементы в нужные массивы , для дальнейшего подсчета длинны и вывода данных в модалки
        el.bookings.filter(bookingElem => {
          if (bookingElem.status !== 'Отменен') {
            filteredObject.dealStatistic.push(bookingElem)
          }
          if (bookingElem.hour_before_confirmed) filteredObject.hoursBeforeConfirmed.push(bookingElem)
          if (bookingElem.status === 'Отменен' && bookingElem.is_deleted) filteredObject.cancelM1.push(bookingElem)
          if (bookingElem.status === 'Отменен' && !bookingElem.is_deleted) filteredObject.cancelMimk.push(bookingElem)
          if (bookingElem.status === 'Завершен') filteredObject.sucssesMC.push(bookingElem)
        })
        let reserveNumber = filteredObject.dealStatistic.length - el.capacity
        if (Math.sign(reserveNumber) === -1) reserveNumber = 0
        //Формируем таблицу
        let rows = [
          {
            info: el,
            cell: isMilitaryTime ? this.$dayjs(el.slot_starts_at).format('HH:mm') : this.$dayjs(el.slot_starts_at).format('hh:mm a')
          },
          {cell: el.capacity},
          {
            cell: el.overbooking_capacity,
            colorCell: ''
          },
          {
            cell: el.mk_booked,
            colorCell: ''
          },
          {cell: reserveNumber},
          {cell: filteredObject.hoursBeforeConfirmed},
          {cell: filteredObject.cancelM1},
          {cell: filteredObject.cancelMimk},
          {cell: filteredObject.sucssesMC}
        ]
        //Сравниваем определенные колонки в таблице и соответствующим образом красим клетки, если одна больше другой
        if (filteredObject.hoursBeforeConfirmed.length > el.capacity) rows[5].colorCell = '#ff424288'
        if (el.mk_booked > el.overbooking_capacity ) rows[3].colorCell = '#ff424288'
        else rows[3].colorCell = '#68ff4288'
        return rows
      })
      //Обнуляем массив таблицы если там уже есть данные и пушим данные
      if (this.tableData.statistic.length) this.tableData.statistic = []
      this.tableData.statistic.push(...newArrayStatistic)
    },
    closeModals() {
      if (this.mimkInfoOnModal) this.mimkInfoOnModal = false
      this.isVisibleModalStatistic = false
    },
    //При изменении даты, запрашиваем новую статистику
    async changeDate(date) {
      this.loader = true
      const formatDate = this.$dayjs(date, 'DD.MM.YYYY').format('YYYY-MM-DD')
      this.statistic = await apiTimeslots.getTimeslotsStatistic(formatDate, this.filterTags)
      this.getStatistic()
      this.loader = false
    }
  },
  computed: {
    today() {
      const segment = this.$store.state.user.segment
      return this.$dayjs(segment.segment_local_time, 'YYYY-MM-DD HH:mm').format('D MMMM')
    }
  }
}
</script>
<style lang="scss">
.statistic__multiselect {
  background: #fff;
  &.v-select .vs__selected {
    margin-right: 5px;
    height: 30px;
  }
  &.v-select .vs__selected-options {
    overflow: auto;
    padding: 3px 3px 0 3px;
    height: auto;
  }
  &.v-select .vs__dropdown-toggle {
    height: auto;
    min-height: 40px;
    min-width: 140px;
  }
  &.v-select .vs__dropdown-toggle {}
}
</style>
<style lang="scss" scoped>
.column__total {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 400;
}
.statistic-current{
  font-weight: 500;
  color: #485270;
    &__day {
      margin-bottom: 15px;
    }
    &__attention {
      margin-top: 15px;
    }
}

.ps {
  height: 400px;
}
.table-incide-cell {
  cursor: pointer;
  padding: 15px;
}
</style>
